import React, { forwardRef } from "react";

import { ErrorMessage } from "./error-message";
import { Input, type InputProps } from "./input";
import { Label, type LabelProps } from "./label";

type LabelledInputProps = Omit<InputProps, "id" | "style" | "error"> & {
  id: string;
  label: React.ReactChild;
  labelProps?: Pick<LabelProps, "id" | "tooltip" | "semibold">;
  error?: React.ReactChild;
};

export const LabelledInput = forwardRef<HTMLInputElement, LabelledInputProps>(
  function LabelledInput({ label, labelProps, error, ...props }, forwardedRef) {
    return (
      <div className="form-group">
        <Label {...labelProps} htmlFor={props.id} required={props.required}>
          {label}
        </Label>

        <Input
          {...props}
          ref={forwardedRef}
          error={Boolean(error)}
          aria-errormessage={error ? `${props.id}-error` : undefined}
        />

        {error ? <ErrorMessage id={props.id}>{error}</ErrorMessage> : null}
      </div>
    );
  },
);
